import { render, staticRenderFns } from "./returnRecordInitAction.vue?vue&type=template&id=144ce41b&scoped=true"
import script from "./returnRecordInitAction.vue?vue&type=script&lang=js"
export * from "./returnRecordInitAction.vue?vue&type=script&lang=js"
import style0 from "./returnRecordInitAction.vue?vue&type=style&index=0&id=144ce41b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ce41b",
  null
  
)

export default component.exports